import { ELibraryFrontApi } from "../../../../api/e-library/e_library_front.api";
import { LIBRARY_LIKE } from "../../enum/elibrary_enum";

const COOLDOWN_MS = 1000;
const inFlight = new Set<string>();                 
const lastActionAt = new Map<string, number>();    

const makeKey = (id: number, type: LIBRARY_LIKE) => `${id}:${type}`;

export const globalLikeBookmark = async (
    id_library_head: number,
    type: LIBRARY_LIKE
): Promise<boolean> => {
    const key = makeKey(id_library_head, type);
    const now = Date.now();

    if (inFlight.has(key)) return false;
    const last = lastActionAt.get(key) ?? 0;
    if (now - last < COOLDOWN_MS) return false;

    inFlight.add(key);
    lastActionAt.set(key, now);

    try {
        const res = await ELibraryFrontApi.likeBookmark({ id_library_head, type });
        return res?.status < 300;
    } catch (e) {
        console.error(e);
        return false;
    } finally {
        inFlight.delete(key);
    }
};
